import CurrencyNumber from "app/components/CurrencyNumber/CurrencyNumber";
import { TimeDateHelper } from "app/helpers/timeDateHelper";
import { ExchangeMarketRowType } from "app/types/reportType";
import React from "react";

const StatementExchangeMarketsContent: React.FC<{
  statementList: ExchangeMarketRowType[];
  loadStatementExchangeBetsPerMarket: Function;
}> = ({ statementList, loadStatementExchangeBetsPerMarket }) => {
  return (
    <>
      {statementList.map((entry: ExchangeMarketRowType, index: number) => (
        <React.Fragment key={index}>
          <div
            className={
              "statement-exchange-cell statement-exchange-cell--multiline"
            }
          >
            <span>
              {TimeDateHelper.getFormattedDateTime(entry.date, "DD/MM/YYYY")}
            </span>
            <span>
              {TimeDateHelper.getFormattedDateTime(entry.date, "HH:mm:ss")}
            </span>
          </div>
          <div
            className={
              "statement-exchange-cell statement-exchange-cell--multiline"
            }
          >
            <span>{entry.sport}</span>
            <span>{entry.market}</span>
            <span>{entry.period}</span>
          </div>
          <div
            className={
              "statement-exchange-cell statement-exchange-cell--multiline"
            }
          >
            <span>{entry.competition}</span>
            <span
              className="statement-exchange__content__link"
              onClick={() => {
                loadStatementExchangeBetsPerMarket(entry.marketId);
              }}
            >
              {entry.eventName}
            </span>
          </div>
          <div
            className={
              "statement-exchange-cell statement-exchange-cell--number"
            }
          >
            <CurrencyNumber value={entry.marketSubtotal} />
          </div>
          <div
            className={
              "statement-exchange-cell statement-exchange-cell--number"
            }
          >
            <CurrencyNumber value={entry.commission} />
          </div>
          <div
            className={
              "statement-exchange-cell statement-exchange-cell--number"
            }
          >
            <CurrencyNumber value={entry.payout} />
          </div>
        </React.Fragment>
      ))}
    </>
  );
};

export default StatementExchangeMarketsContent;
